import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type UpgradePromptProps = {
  variant: "sm" | "lg";
  /** Zalogowany użytkownik — wpływa na CTA (trial vs PRO vs login). */
  authenticated: boolean;
  canStartTrial: boolean;
  onStartTrial: () => void | Promise<void>;
  onGoPro: () => void;
  onLogin?: () => void;
  className?: string;
};

/**
 * Blokada funkcji PRO — inline (sm) lub karta/modalowy układ (lg).
 * Cena: Early Access (bez checkoutu w tym passie).
 */
export function UpgradePrompt({
  variant,
  authenticated,
  canStartTrial,
  onStartTrial,
  onGoPro,
  onLogin,
  className,
}: UpgradePromptProps) {
  const body = (
    <>
      <p className={cn(variant === "lg" ? "text-base leading-relaxed" : "text-sm leading-snug")}>
        Ta funkcja jest dostępna w planie PRO
      </p>
      <div
        className={cn(
          "flex flex-wrap items-center gap-2",
          variant === "sm" ? "mt-1.5" : "mt-4"
        )}
      >
        {!authenticated ? (
          <>
            {onLogin ? (
              <Button type="button" size={variant === "lg" ? "default" : "sm"} onClick={onLogin}>
                Zaloguj się
              </Button>
            ) : null}
            <Button type="button" variant="outline" size={variant === "lg" ? "default" : "sm"} asChild>
              <Link to="/ustawienia">Early Access — cena wkrótce</Link>
            </Button>
          </>
        ) : canStartTrial ? (
          null
        ) : (
          <Button type="button" size={variant === "lg" ? "default" : "sm"} onClick={onGoPro}>
            Przejdź na PRO →
          </Button>
        )}
      </div>
    </>
  );

  if (variant === "lg") {
    return (
      <div
        className={cn(
          "rounded-xl border border-border/80 bg-card p-6 shadow-sm",
          className
        )}
      >
        {body}
        <p className="mt-3 text-xs text-muted-foreground">Early Access — cena wkrótce</p>
      </div>
    );
  }

  return <div className={cn("text-left", className)}>{body}</div>;
}
